export interface BillingAddresses {
  billing_address: {
    customer_address_id: boolean
    city: boolean
    country: {
      code: boolean
      label: boolean
      [key: string]: any
    }
    firstname: boolean
    lastname: boolean
    postcode: boolean
    street: boolean
    telephone: boolean
    company: boolean
    region: {
      code: boolean
      label: boolean
      [key: string]: any
    }
    [key: string]: any
  }
}

export const billingAddresses = {
  billing_address: {
    customer_address_id: true,
    city: true,
    country: {
      code: true,
      label: true
    },
    firstname: true,
    lastname: true,
    postcode: true,
    company: true,
    region: {
      code: true,
      label: true
    },
    street: true,
    telephone: true
  }
}
